import styled from 'styled-components';
import { transparentize } from 'polished';
/**
 * Footer
 *
 * This component is in charge of display
 * the footer of Card component
 *
 *
 * @return {jsx}
 */

var Footer = styled.div.withConfig({
  displayName: "Footer",
  componentId: "u10v63-0"
})(["box-shadow:0 -1px 2px 0 ", ";border-top:solid 1px ", ";display:flex;align-items:center;justify-content:center;height:4.9rem;padding:0 2rem;"], function (_ref) {
  var palette = _ref.theme.palette;
  return transparentize(0.96, palette.black);
}, function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.veryLightBlue;
});
export default Footer;